module.exports = __webpack_public_path__ + "img/logo-light.2b0f21ce.png";